export default __webpack_public_path__ + "src/images/packages/marataba-conservation-camps/b8b4ed5d36c2f733029bfcdaf82fc5bb-2.jpg";